var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.008 29.3226C4.7645 31.0806 7.5935 31.0806 13.25 31.0806H19.25C24.9065 31.0806 27.7355 31.0806 29.492 29.3226C31.2485 27.5646 31.25 24.7371 31.25 19.0806C31.25 17.3256 31.25 15.8436 31.1975 14.5806M29.492 8.83857C27.7355 7.08057 24.9065 7.08057 19.25 7.08057H13.25C7.5935 7.08057 4.7645 7.08057 3.008 8.83857C1.2515 10.5966 1.25 13.4241 1.25 19.0806C1.25 20.8356 1.25 22.3176 1.3025 23.5806M16.25 1.08057C19.079 1.08057 20.492 1.08057 21.371 1.95957C22.25 2.83857 22.25 4.25157 22.25 7.08057M11.129 1.95957C10.25 2.83857 10.25 4.25157 10.25 7.08057",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 24.0801C17.9075 24.0801 19.25 22.9611 19.25 21.5811C19.25 20.2011 17.9075 19.0806 16.25 19.0806C14.5925 19.0806 13.25 17.9616 13.25 16.5801C13.25 15.2001 14.5925 14.0811 16.25 14.0811M16.25 24.0801C14.5925 24.0801 13.25 22.9611 13.25 21.5811M16.25 24.0801V25.0806M16.25 14.0811V13.0806M16.25 14.0811C17.9075 14.0811 19.25 15.2001 19.25 16.5801",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainFinance);
export default __webpack_public_path__ + "static/media/mainFinance.c2d9cee3064deda6745343ffe27f29e2.svg";
export { ForwardRef as ReactComponent };